import { Box, IconButton, makeStyles } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import React from "react";
import styled from "styled-components";
import SecondaryButton from "../../UI/Buttons/SecondaryButton";
import VerifiedStatusChip from "../../VerifiedStatusChip";

const StyledCard = styled(Card)`
  &.MuiCard-root {
    padding: 0px;
  },
  &.MuiPaper-elevation1 {
    box-shadow: 0 7px 30px -10px rgba(150, 170, 180, 0.5);
  },
`;

const StyledCardContent = styled(CardContent)`
  &.MuiCardContent-root {
    padding: 16px;
    min-height: 135px;
  }
`;

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: "0px 16px 16px 16px",
  },
  footerItem: {
    width: "100%",
  },
  header: {
    ...theme.typography.body2,
    ...theme.typography.semiBold,
  },
  subheader: {
    ...theme.typography.body2,
    marginTop: 8,
  },
  label: {
    ...theme.typography.body2,
    ...theme.typography.semiBold,
  },
  contentHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: `5px`,
  },
}));

const WebsiteCard = ({ data, setCurrentDelete, history, id }) => {
  const classes = useStyles();

  return (
    <StyledCard>
      <StyledCardContent>
        <Box className={classes.contentHeader}>
          <Box>
            <h2 className={classes.header}>{data?.title ?? ""}</h2>
          </Box>
          <VerifiedStatusChip
            label={`${data?.type ?? "General"}`}
            data-status="dark"
          />
        </Box>
        {data?.type === "Location" && data?.location?.id && (
          <h3 className={classes.subheader}>
            <span className={classes.label}>Location :</span>{" "}
            {data?.location?.title}
          </h3>
        )}
        <h3
          className={classes.subheader}
          style={{ display: "flex", alignItems: "center" }}
        >
          <span className={classes.label}>API Key :</span>{" "}
          {data?.api_key?.substring(0, 10) + "..."}
          <IconButton
            style={{ marginLeft: 8 }}
            onClick={() => navigator.clipboard.writeText(data?.api_key)}
          >
            <FileCopyIcon
              style={{ width: "15px", height: "15px", color: "#0a0a29" }}
            />
          </IconButton>
        </h3>
      </StyledCardContent>

      <Box className={classes.footer}>
        <Box className={classes.formInput}>
          <SecondaryButton
            style={{ width: "100%" }}
            onClick={() => {
              history.push(`/d/website/${id}/pages`);
            }}
          >
            Manage Pages
          </SecondaryButton>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default WebsiteCard;
